import * as apicall from "../components/Apicall";

/* Company (B2B bill-to) customers - the Customers screen's "Companies" tab.
   Individuals keep using the ezp_customers endpoints (see pages/Customers). */

export const listCompanies = ({ page = 1, limit = 10, search = "" } = {}) => {
  const params = new URLSearchParams({ page, limit });
  if (search) params.set("search", search);
  return apicall.get(`ezp_company_customers?${params.toString()}`);
};

// Throws when the company does not exist (apicall.get rejects on a 404).
export const getCompany = (id) => apicall.get(`ezp_company_customers/${id}`);

// Resolves { success, data } or { success: false, message, field? } - never throws on a validation error.
export const updateCompany = (id, payload) => apicall.post(payload, `ezp_company_customers/${id}`);
